import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Carousel, CarouselItem, CarouselControl, CarouselIndicators, Button } from 'reactstrap';

import { getReviewSummary } from '../../ReviewActions';
import { getLanguagePath } from '../../../Intl/IntlActions';

import ReviewListItem from '../list/ReviewListItem';
import FontCustom from '../../../../components/Content/FontCustom';

class ReviewSummary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reviews: [],
            // average: null,
            activeSlide: 0,
        };
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.locale !== this.props.locale) {
            this.init();
        }
    }

    init = () => {
        this.props.dispatch(getReviewSummary(this.props.locale)).then(result => {
            this.setState(result);
        });
    }

    handlePrev = () => {
        this.state.activeSlide > 1 && this.goToSlide(this.state.activeSlide - 1);
    }

    handleNext = () => {
        (this.state.activeSlide + 1) < this.state.reviews.length && this.goToSlide(this.state.activeSlide + 1);
    }

    goToSlide = newIndex => {
        this.setState({
            activeSlide: newIndex,
        });
    }

    render() {
        return (
            <Container className="py-3 py-md-5 bg-white">
                <div className="position-relative mb-4 py-3 text-center text-dark font-weight-bold">
                    <div className="position-relative" style={{ zIndex: 2 }}>
                        <span className="text-uppercase text-warning"><FormattedMessage id="reviews" defaultMessage="Reviews" /></span>
                        <span className="d-block h3"><FormattedMessage id="reviewSummaryTitle" defaultMessage="Our customers talk about it the best, find out their opinions!" /></span>
                    </div>
                    <span className="position-absolute w-100 text-center text-light" style={{ top: '20px', left: '0', zIndex: 1 }}>
                        <FontCustom name="quote" size="10" />
                    </span>
                </div>

                <Carousel activeIndex={this.state.activeSlide} previous={this.handlePrev} next={this.handleNext}>
                    <CarouselIndicators items={this.state.reviews} activeIndex={this.state.activeSlide} onClickHandler={this.goToSlide} className="mt-3" />
                    {this.state.reviews.map(review => (
                        <CarouselItem tag="div" key={review._id} className="text-center">
                            <ReviewListItem review={review} isSummary />
                        </CarouselItem>
                    ))}
                </Carousel>

                <div className="mt-5 text-center">
                    <Button color="warning" tag={Link} to={getLanguagePath('/reviews', this.props.locale)}><FormattedMessage id="reviewSummaryButton" defaultMessage="Discover the reviews" /></Button>
                </div>
            </Container>
        );
    }
}

ReviewSummary.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    locale: PropTypes.string.isRequired,
};

export default connect()(injectIntl(ReviewSummary));
